import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { buttonClass } from '../../utils/styles';
type FormValidatedPanelProps = {
  formId: string;
  title: string;
  message: string;
  onEdit: () => void;
  onReset: () => void;
};
export function FormValidatedPanel({
  formId,
  title,
  message,
  onEdit,
  onReset
}: FormValidatedPanelProps) {
  const reduceMotion = useReducedMotion();
  return <motion.div id={`${formId}-status`} tabIndex={-1} role="status" initial={reduceMotion ? false : {
    opacity: 0,
    y: 8
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.25,
    ease: [0.23, 1, 0.32, 1]
  }} className="focus:outline-none" data-id="element-71" data-mp="26v3h9l1ad508">
      <span className="flex h-11 w-11 items-center justify-center rounded-full border border-gold text-gold-deep" data-id="element-72" data-mp="2ljhrih117vqt">
        <CheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-73" data-mp="2qh9kzfhbrpx4" />
      </span>
      <h3 className="mt-6 font-serif text-[1.85rem] font-medium leading-tight text-navy" data-id="element-74" data-mp="2ulh8xafyl1ua">{title}</h3>
      <p className="mt-3 text-[15px] leading-relaxed text-ink" data-id="element-75" data-mp="1a9tnfelov21m">{message}</p>
      <div className="mt-6 border-l-2 border-gold bg-paper px-5 py-4" data-id="element-76" data-mp="15849nr730a9u">
        <p className="text-sm font-medium text-navy" data-id="element-77" data-mp="109szffcvjxr3">Not yet sent</p>
        <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-78" data-mp="10c5ffmz2ny1i">
          Online submission has not been connected, so nothing has been sent, uploaded or stored. Submission will
          be enabled once a secure system is in place.
        </p>
      </div>
      <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-79" data-mp="1o0onc1e7m8t2">
        <button type="button" onClick={onEdit} className={buttonClass('outlineDark')} data-id="element-80" data-mp="1j8x7aksojlh6">
          Review details
        </button>
        <button type="button" onClick={onReset} className={buttonClass('navy')} data-id="element-81" data-mp="1ealxga2dxayy">
          Clear form
        </button>
      </div>
    </motion.div>;
}